import firebase from "firebase/app";
import "firebase/firestore";
import { useEffect } from "react";
import { IMessage } from "react-native-gifted-chat";
import { useSelector } from "react-redux";
import api from "src/util/api";
import { tMessage, tThread, validate } from "tmt_api/src/types/types.validator";
import { tReduxAction } from "../types";
import { errorFactory } from "../../util/errorFactory";
import { useAppDispatch } from "src/redux";

// TODO: to be used later when needing to create message threads for everyone.
// export function createNewMessageThreads(
//   recipientIds: Array<string>,
//   recipientNames: { [id: string]: string },
// ): tMessageThreadsThunkDispatch {
//   return (dispatch, getState) => {
//     const { profile } = getState().UserReducer;
//     const { messageThreads } = getState().MessageThreadsReducer;
//     const newMessageThreadId = uuid.v4().toString();
//     const threadUsers = [...recipientIds, profile.uid];
//     const kLastMessageDate = firebase.firestore.Timestamp.fromDate(new Date());
//     const kUserConversation = {
//       id: newMessageThreadId,
//       recipient: threadUsers.find((id) => id !== profile.uid) ?? "",
//       recipientStr: "",
//       messages: [],
//       lastMessageDate: kLastMessageDate,
//     };
//     threadUsers.forEach((recipientId) => {
//       let aRecipientStr = "";
//       Object.keys(recipientNames).forEach((id) => {
//         if (id !== recipientId) {
//           aRecipientStr += `${recipientNames[id]}, `;
//         }
//       });
//       aRecipientStr = aRecipientStr.substring(0, aRecipientStr.length - 2);
//       if (recipientId === profile.uid) {
//         kUserConversation.recipientStr = aRecipientStr;
//       }
//       const newConversation = {
//         id: newMessageThreadId,
//         recipient: threadUsers.find((id) => id !== recipientId),
//         recipientStr: aRecipientStr,
//         lastMessageDate: kLastMessageDate,
//       };
//       firebase
//         .firestore()
//         .collection("users")
//         .doc(recipientId)
//         .collection(kFirestoreCollections.messageThreads)
//         .doc(newMessageThreadId)
//         .set(newConversation)
//         .catch((e) => console.error(e));
//     });
//     const kNewMessageThreads = messageThreads;
//     kNewMessageThreads.push(kUserConversation);
//     dispatch(setMessageThreads(kNewMessageThreads));
//   };
// }

export const useFetchMessages = (): void => {
  const dispatch = useAppDispatch();
  const kAccountType = useSelector((state) => state.UserReducer?.profile?.accountType);
  const kUID = useSelector((state) => state.UserReducer?.profile?.uid);
  const companyRefPath = useSelector((state) => state.UserReducer?.profile?.companyRefPath);
  const rCurrentThreadId = useSelector((state) => state.MessageThreadsReducer.rCurrentThreadId);
  const currentSearch = useSelector(({ SearchReducer }) => SearchReducer?.rSearchData?.messageData?.currentSearch);

  // threads
  useEffect(() => {
    let kRefPath: string;
    if (kAccountType === "tmtAdmin") {
      kRefPath = `users/${kUID}`;
    } else if (!companyRefPath) {
      dispatch({ type: "UPDATE_MESSAGE_THREADS", rThreads: [] });
      dispatch(setCurrentThread(null));
      return undefined;
    } else {
      kRefPath = companyRefPath;
    }
    const validateThread = validate("tThread");
    // TODO: add pagination w / cursors
    return firebase
      .firestore()
      .doc(kRefPath)
      .collection("message_threads")
      .onSnapshot(
        (querySnapshot) => {
          try {
            if (querySnapshot.empty) {
              dispatch({ type: "UPDATE_MESSAGE_THREADS", rThreads: [] });
              return undefined;
            }
            const aThreads = querySnapshot.docs.map((doc) => validateThread(doc.data()));
            dispatch({ type: "UPDATE_MESSAGE_THREADS", rThreads: aThreads });
          } catch (e) {
            const error = errorFactory(e);
            dispatch({
              type: "ERROR",
              error: error instanceof Error ? error : new Error("Message fetch error"),
            });
          }
          return undefined;
        },
        (error) => {
          dispatch({
            type: "ERROR",
            error,
          });
        },
      );
  }, [dispatch, companyRefPath, currentSearch, kAccountType, kUID]);

  // messages
  useEffect(() => {
    if (!rCurrentThreadId) {
      dispatch({ type: "UPDATE_CURRENT_THREAD", rCurrentMessages: [] });
      return undefined;
    }
    const validateMessage = validate("tMessage");
    return firebase
      .firestore()
      .collection("messages")
      .where("threadId", "==", rCurrentThreadId)
      .orderBy("createdAt", "desc")
      .limit(2000) // TODO: add pagination w / cursors
      .onSnapshot(
        (querySnapshot) => {
          try {
            if (querySnapshot.empty) {
              dispatch({ type: "UPDATE_CURRENT_THREAD", rCurrentMessages: [] });
              return undefined;
            }
            const aCurrentMessages = querySnapshot.docs.map((doc) => validateMessage(doc.data()));
            dispatch({ type: "UPDATE_CURRENT_THREAD", rCurrentMessages: aCurrentMessages });
            dispatch({
              type: "SET_LOADING_MESSAGES",
              loading: false,
            });
          } catch (e) {
            const error = errorFactory(e);
            dispatch({
              type: "ERROR",
              error: new Error(`Error: ${error?.message} | ${error?.stack}`),
            });
            dispatch({ type: "UPDATE_CURRENT_THREAD", rCurrentMessages: [] });
          }
          return undefined;
        },
        (error: Error) => {
          dispatch({
            type: "ERROR",
            error,
          });
          dispatch({ type: "UPDATE_CURRENT_THREAD", rCurrentMessages: [] });
        },
      );
  }, [dispatch, rCurrentThreadId]);
};

// export const useFetchMessageRecipients = (): void => {
//   const dispatch = useAppAction();

//   useEffect(() => {
//     if (!profile.companyRefPath) {
//       return undefined;
//     }

//     dispatch({
//       type: "SET_LOADING_MESSAGE_RECIPIENTS",
//       loading: true,
//     });

//     const unsubscribe = firebase
//       .firestore()
//       .doc(profile.companyRefPath)
//       .collection(kFirestoreCollections.messageThreads)
//       .where("search", "array-contains", rSearchData?.messageData?.currentSearch ?? "")
//       .onSnapshot((messageThreads) => {
//         if (messageThreads.empty) {
//           return undefined;
//         }
//         Promise.all(
//           messageThreads.docs.map((messageThread) => {
//             const { recipient } = validate("tConversationDocument")(messageThread.data());
//             return firebase
//               .firestore()
//               .doc(recipient)
//               .get()
//               .then((company) => {
//                 return {
//                   recipient,
//                   company: validate("tRecipient")(company.data()),
//                 };
//               });
//           }),
//         )
//           .then((myRecipients) => {
//             const messageRecipients: tRecipients = {};
//             myRecipients.forEach(({ recipient, company }) => {
//               messageRecipients[recipient] = company;
//             });
//             dispatch(setMessageRecipients(messageRecipients));
//             dispatch({
//               type: "SET_LOADING_MESSAGE_RECIPIENTS",
//               loading: false,
//             });
//           })
//           .catch((error) => {
//             console.warn(
//               `An error occurred fetching messages! Error: message: ${error?.message}, stack: ${error?.stack}`,
//             );
//             dispatch({
//               type: "SET_LOADING_MESSAGE_RECIPIENTS",
//               loading: false,
//             });
//           });
//         return undefined;
//       });
//     return unsubscribe;
//   }, [dispatch, profile.companyRefPath, profile.uid, rSearchData?.messageData?.currentSearch]);
// };

type tpSendMessage = (myNewIMessages: IMessage[]) => tReduxAction;
export const sendMessage: tpSendMessage = (myNewIMessages) => (dispatch, getState) => {
  const rState = getState();
  const rCompanyRefPath = rState?.UserReducer?.profile?.companyRefPath;
  const rCurrentThreadId = rState?.MessageThreadsReducer?.rCurrentThreadId;
  if (!rCurrentThreadId) {
    dispatch({
      type: "ERROR",
      error: new Error("Tried to send a message to an unspecified connection!"),
    });
    return;
  }
  const aCurrentMsgThread = rState?.MessageThreadsReducer?.rThreads.find((m) => m.id === rCurrentThreadId);
  const myThreadLocations: string[] = [];
  if (rCompanyRefPath) myThreadLocations.push(rCompanyRefPath);
  if (aCurrentMsgThread?.recipient) myThreadLocations.push(aCurrentMsgThread?.recipient);
  const myNewMessages: tMessage[] = myNewIMessages
    .filter((message) => !!message.text)
    .map((message) => ({
      _id: message._id,
      threadId: rCurrentThreadId,
      text: message.text,
      createdAt: new Date(message.createdAt).toISOString(),
      user: { _id: message.user._id },
    }));
  if (myNewMessages.length > 0) {
    // message loading
    dispatch({
      type: "SET_LOADING_MESSAGES",
      loading: true,
    });
    api
      .post({ endpoint: "/messages", body: { myNewMessages, myThreadLocations, mySenderRefPath: rCompanyRefPath } })
      .catch((e: Error) => {
        dispatch({
          type: "ERROR",
          error: e,
        });
        dispatch({
          type: "SET_LOADING_MESSAGES",
          loading: false,
        });
      });
  }
};

type tpSendBotMessage = (myNewIMessages: IMessage[]) => tReduxAction;
export const sendBotMessage: tpSendBotMessage = (myNewBotIMessages) => (dispatch, getState) => {
  const rState = getState();

  const rCompanyRefPath = rState?.UserReducer?.profile?.companyRefPath;
  const rBotThreadId = rState?.MessageThreadsReducer?.rThreads.filter((myThread) =>
    myThread.recipient.includes("tmt_bot"),
  )[0]?.id;
  if (!rBotThreadId) {
    dispatch({
      type: "ERROR",
      error: new Error("Tried to send a message to an unspecified connection!"),
    });
    return;
  }
  const aCurrentMsgThread = rState?.MessageThreadsReducer?.rThreads.find((m) => m.id === rBotThreadId);
  const myThreadLocations: string[] = [];
  if (rCompanyRefPath) myThreadLocations.push(rCompanyRefPath);
  if (aCurrentMsgThread?.recipient) myThreadLocations.push(aCurrentMsgThread?.recipient);
  const myNewMessages: tMessage[] = myNewBotIMessages.map((message) => ({
    _id: message._id,
    threadId: rBotThreadId,
    text: message.text,
    createdAt: new Date(message.createdAt).toISOString(),
    user: { _id: message.user._id },
  }));
  // message loading
  dispatch({
    type: "SET_LOADING_MESSAGES",
    loading: true,
  });
  api
    .post({ endpoint: "/messages", body: { myNewMessages, myThreadLocations, mySenderRefPath: "tmt_bot" } })
    .then(() => {
      dispatch({
        type: "SET_LOADING_MESSAGES",
        loading: false,
      });
    })
    .catch((e) => {
      dispatch({
        type: "ERROR",
        error: e,
      });
    });
};

// TODO: this does not use promises correctly!
// export const addConnectionsData = (myNewMessages: IMessage[], mySelectedId: string | undefined): tThunkDispatch => (
//   dispatch,
// ) => {
//   try {
//     axios.post(`${API_URL}/messages`, { myNewMessages, mySelectedId });

//     dispatch({
//       type: "SET_LOADING_MESSAGES",
//       loading: false,
//     });
//   } catch (error) {
//     dispatch({
//       type: "ERROR",
//       error,
//     });
//   }
// };

type tpSetCurrentThread = (val: string | tThread | null) => tReduxAction;
export const setCurrentThread: tpSetCurrentThread = (val) => (dispatch, getState) => {
  const rState = getState();
  let anId: string;
  let aThread: tThread | null;
  if (val === null) {
    anId = "";
    aThread = null;
  } else if (typeof val === "string") {
    anId = val;
    const aThreadMaybe = rState?.MessageThreadsReducer?.rThreads.find((myThread) => myThread.id === val);
    if (!aThreadMaybe) throw new Error("Thread not found");
    aThread = aThreadMaybe;
  } else {
    anId = val.id;
    aThread = val;
  }
  dispatch({ type: "SET_CURRENT_THREAD", currentThread: aThread });
  dispatch({ type: "SET_CURRENT_THREAD_ID", rCurrentThreadId: anId });
};
